import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Modal,  InputGroup, Input, ModalHeader, ModalBody, ModalFooter, InputGroupAddon, InputGroupText } from 'reactstrap'
import editAdminUser from '../../../api/editAdminUser';
import { showToastAction } from '../../../redux/toastSlice';

const UserModal = ({ show, handleClose }) => {
    const selectedAdminUser = useSelector((state) => state.selectedAdminUser);
    const [data, setData] = useState({});
    const dispatch = useDispatch()

    if (!selectedAdminUser) return <></>;

    const { first_name, last_name, email_adress, password, user_type, user_status, username, user_creation_date, user_created_by, user_last_modification_date, user_modified_by } = selectedAdminUser

    const updateData = (key, value) => {
        const newData = { ...data };
        newData[key] = value;
        setData({ ...newData });
    }

    const submitUser = async () => {
        try {
            await editAdminUser(selectedAdminUser.username, { ...data, password: data.password || password, email_adress: data.email_adress || email_adress, first_name: data.first_name || first_name, last_name: data.last_name || last_name, });
            handleClose();
            dispatch(showToastAction({ message: "User Edited", showToast: true, severity: "success" }))

        }
        catch (err) {
            dispatch(showToastAction({ message: err.response?.data?.errorMessage ?? "Error", showToast: true }))
        }
    }

    return (
        <Modal isOpen={show} toggle={handleClose}>
            <ModalHeader toggle={handleClose}>
                Update User
            </ModalHeader>
            <ModalBody>
                {/* <h3 className="fw-bolder mb-6">User 1</h3> */}
                <div className="flex flex-col gap-4">
                    <UserProperty property="First Name" value={data.first_name} defaultValue={first_name} onChange={(e) => updateData("first_name", e.target.value)} />
                    <UserProperty property="Last Name" value={data.last_name} defaultValue={last_name} onChange={(e) => updateData("last_name", e.target.value)} />
                    <UserProperty property="Email" value={data.email_adress} defaultValue={email_adress} onChange={(e) => updateData("email_adress", e.target.value)} />
                    <SelectUserProperty property="User type" value={data.user_type} defaultValue={user_type} onChange={(e) => updateData("user_type", e.target.value)} options={["MASTER", "CAPTURE", "ADMIN"]} />
                    <SelectUserProperty property="User status" value={data.user_status} defaultValue={user_status} onChange={(e) => updateData("user_status", e.target.value)} options={["ACTIVE", "INACTIVE"]} />
                    <UserProperty disabled property="Username" value={data.username} defaultValue={username} onChange={(e) => updateData("username", e.target.value)} />
                    <UserProperty disabled property="Creation" value={data.user_creation_date} defaultValue={user_creation_date} onChange={(e) => updateData("user_creation_date", e.target.value)} />
                    <UserProperty disabled property="Created by" value={data.user_created_by} defaultValue={user_created_by} onChange={(e) => updateData("user_created_by", e.target.value)} />
                    <UserProperty disabled property="Last modification" value={data.user_last_modification_date} defaultValue={user_last_modification_date} onChange={(e) => updateData("user_last_modification_date", e.target.value)} />
                    <UserProperty disabled property="Modified by" value={data.user_modified_by} defaultValue={user_modified_by} onChange={(e) => updateData("user_modified_by", e.target.value)} />
                </div>
            </ModalBody>
            <ModalFooter>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={submitUser}>
                    Confirm
                </Button>
            </ModalFooter>
        </Modal>
    );
}

const UserProperty = ({ property, value, onChange, defaultValue, disabled, type }) =>
    <InputGroup>
        <InputGroupAddon addonType="prepend">
            <InputGroupText>{property}</InputGroupText>
        </InputGroupAddon>
        <Input
            disabled={disabled ? true : false}
            defaultValue={defaultValue}
            onChange={onChange}
            value={value}
            type={type ? type : 'text'}
        />
    </InputGroup>

const SelectUserProperty = ({ property, value, onChange, options, defaultValue }) =>
    <InputGroup classname="flex">
        <InputGroupAddon addonType="prepend">
            <InputGroupText>{property}</InputGroupText>
        </InputGroupAddon>
        <Form style={{ flex: 1 }}>
            <Form.Control defaultValue={defaultValue} classname="flex-1" value={value} as="select" onChange={onChange}>
                {options.map((el) => <option value={el} onChange={onChange}>{el}</option>)}
            </Form.Control>
        </Form>
    </InputGroup>


export default UserModal
